import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * External system reference numbers.
 *
 * @remarks
 * System-managed record storing typed reference numbers from external integration
 * systems. Used by CarsArrive, Central Dispatch, and other integrations.
 *
 * Common keys include:
 * - CarsArrive: companyId, loadId, vendorQuoteId, vendorCompanyId
 * - Central Dispatch: dispatchId, dispatchVehicleId
 */
export const schema = z.record(z.string()).optional();

export type ReferenceNumbers = z.infer<typeof schema>;

export const definition = define({
  key: 'referenceNumbers',
  schema,
  label: 'Reference Numbers',
  description:
    'External system reference IDs from CarsArrive, Central Dispatch, etc. Set by integrations, not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
